module.exports = __webpack_public_path__ + "static/img/2.29c23ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/2.jpg
// module id = Y7Jb
// module chunks = 17